import { POST } from "../APiHelper/API"
let source;
export const getPlayerStatsGameAPI = (fixture_id, team_id, player_id, onSuccess, onError) => {
    const data = {
        fixture_id: fixture_id,
        team_id: team_id,
        player_id: player_id
    }

    source = POST(`/api/v1/players_stats/player_in_game`, data, onSuccess, onError, true, source)
}